module.exports = __webpack_public_path__ + "phonecall.svg?17477523922cdbdfee5b2cbb1af52c10";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phonecall.svg
// module id = 60
// module chunks = 0